import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { BalanceFilterDto } from '@models/balance/balance-filter.dto';
import { BalanceDto } from '@models/balance/balance.dto';
import { TransactionFilterDto } from '@models/balance/transaction-filter.dto';
import { TransactionDto } from '@models/balance/transaction.dto';

@Injectable({
  providedIn: 'root',
})
export class BalanceService {
  private readonly basePath = '';

  private readonly BS_ROUTES = {
    list: () => `${this.basePath}/balance/list`,
    currentYearMovements: () => `${this.basePath}/balance/movements`,
    olderYearMovements: (year: number) =>
      `${this.basePath}/balance/older/${year}`,
    addMovement: () => `${this.basePath}/balance/add`,
    removeMovement: () => `${this.basePath}/balance/remove`,
  };

  constructor(private http: HttpClient) {}

  getBalances(filter: BalanceFilterDto) {
    return this.http.post<BalanceDto[]>(
      environment.host + '/balance/list',
      filter,
    );
  }

  createBalance(subs: BalanceDto[]) {
    return this.http.post<BalanceDto[]>(
      environment.host + '/balance/create',
      subs,
    );
  }

  modifyBalance(subs: BalanceDto[]) {
    return this.http.post<BalanceDto[]>(
      environment.host + '/balance/modify',
      subs,
    );
  }

  removeBalance(subs: BalanceDto[]) {
    return this.http.post<BalanceDto[]>(
      environment.host + '/balance/remove',
      subs,
    );
  }

  getTransactions(filter: TransactionFilterDto) {
    return this.http.post<TransactionDto[]>(
      environment.host + '/transaction/list',
      filter,
    );
  }

  createTransaction(subs: TransactionDto) {
    return this.http.post(environment.host + '/transaction/create', subs);
  }

  removeTransaction(subs: TransactionDto) {
    return this.http.post(environment.host + '/transaction/remove', subs);
  }
}
